import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { gdBusinessModels } from "../gdModulesData";
import GdImagePlaceholder from "./GdImagePlaceholder";

const cardVariants = {
  hidden: { opacity: 0, y: 28 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] },
  }),
};

const GdBusinessModelSection: React.FC = () => {
  return (
    <section className="gd-models" aria-labelledby="gd-models-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2
            id="gd-models-title"
            className="wdev-section-head__title wdev-section-head__title--dark wdev-section-head__title--underline"
          >
            Popular On-Demand Grocery App Business Model
          </h2>
          <p className="gd-models__lead">
            Our tailored grocery app development services meet your unique app ideas and vision for
            your grocery app solutions. We at <strong>WebTech</strong> create grocery delivery mobile
            apps suitable for Single Grocery Shop Owners, Multi-Vendor Grocery Marketplace, and
            Grocery Chain Stores. We will match your unique requests and objectives with our
            best-fit grocery app development solutions.
          </p>
        </AnimatedSection>

        <div className="gd-models__grid">
          {gdBusinessModels.map((model, index) => (
            <motion.article
              key={model.title}
              className="gd-models-card"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-40px" }}
              custom={index}
              variants={cardVariants}
              whileHover={{ y: -6, transition: { duration: 0.25 } }}
            >
              <GdImagePlaceholder
                variant="card"
                label={model.placeholderLabel}
                hint={model.placeholderHint}
                className="gd-models-card__placeholder"
              />
              <h3 className="gd-models-card__title">{model.title}</h3>
            </motion.article>
          ))}
        </div>

        <AnimatedSection className="gd-models__cta-wrap" delay={0.2}>
          <Link to="/contact" className="wdev-btn wdev-btn--primary gd-models__cta">
            Share Your Requirement
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path
                d="M3 8h10M9 4l4 4-4 4"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default GdBusinessModelSection;
